//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class AccountUrlConstants
{
	public static accountLoginUrl: string = `/Account/Login`;
	public static accountConfirmLoginUrlTemplate: string = `/Account/ConfirmLogin?loginToken=$loginToken`;
	public static accountLoginLinkSentUrlTemplate: string = `/Account/LoginLinkSent?loginTokenGuid=$loginTokenGuid`;
}
